<div class="email-tags-container" (click)="focusInput()">
  <div class="email-tag" *ngFor="let email of emails; let i = index">
    {{ email }}
    <span class="remove-tag" (click)="removeEmail(i)">×</span>
  </div>
  <input
    #hiddenInput
    type="text"
    [(ngModel)]="inputValue"
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
    class="hidden-input"
    autocomplete="off"
    aria-hidden="true"
    placeholder="Enter Email"
  />
</div>
